import { RoutesService, eLayoutType } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const REFERRERS_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/referrers',
        name: '::Menu:Referrers',
        iconClass: 'fas fa-bullhorn',
        // Beside Partners: a referrer brings in the partners listed there.
        parentName: '::Menu:UserManagement',
        layout: eLayoutType.application,
        requiredPolicy: 'ReturnLy.Referrers',
        order: 4,
      },
    ]);
  };
}
